import styled from "@emotion/styled";

export const Box = styled.div`
  background-color: lightcyan;
  height: 100vh;
  width: 70%;
  padding: 15px;
`;

export const DateTitle = styled.p`
  margin-bottom: 20px;
`;

export const TextInput = styled.input`
  display: block;
  width: 98%;
  margin-bottom: 20px;
  height: 40px;
  padding: 2px 8px;

  border: 0;
  font-size: 28px;
`;

export const TextArea = styled.textarea`
  width: 98%;
  height: 160px;
  padding: 4px 8px;
  border: 0;
  font-size: 24px;
`;

export const Form = styled.form``;
